import reducer from "./reducer";
import { createStore } from "redux";
import { loadState, saveState } from "../Local-storage";

const persistedState = loadState();
export const store = createStore(
  reducer,
  persistedState,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
);

// Yeh line jaruri hai => jab bhi redux state update hogi, localStorage me save hoga
store.subscribe(() => {
  saveState(store.getState()); // Saves to SevanestAdmin
});
